// Youtube, Fb...
const VIDEO = 'video';
// Photo, Frame...
const IMAGE = 'image';

export const UGC_TAB_INDEX = 0;
export const VOTE_TAB_INDEX = 1;

export default { VIDEO, IMAGE };
